/**
 * Autocomplete Google Places pour l'adresse du formulaire d'estimation.
 * Restreint la sélection à une zone autour de Québec sans modifier le payload CRM.
 */
(function () {
  var config = window.tsGooglePlacesConfig || {};
  var centerLat = Number(config.centerLat) || 46.8817314;
  var centerLng = Number(config.centerLng) || -71.1904419;
  var radiusKm = Number(config.radiusKm) || 70;
  var addressInput = null;
  var postalInput = null;
  var geocoder = null;
  var selectedAddress = "";
  var selectedStreetAddress = "";
  var ignoreInputUntil = 0;

  var state = {
    ready: false,
    selected: false,
    withinArea: false,
    message: "Veuillez choisir une adresse dans la liste Google.",
  };

  function normalize(value) {
    return String(value || "")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();
  }

  function distanceKm(lat1, lng1, lat2, lng2) {
    var earthRadiusKm = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLng = ((lng2 - lng1) * Math.PI) / 180;
    var haversineValue =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    return (
      earthRadiusKm *
      (2 * Math.atan2(Math.sqrt(haversineValue), Math.sqrt(1 - haversineValue)))
    );
  }

  function getComponent(place, type, useShortName) {
    var components = place.address_components || [];
    for (var index = 0; index < components.length; index++) {
      if (components[index].types.indexOf(type) !== -1) {
        return useShortName
          ? components[index].short_name
          : components[index].long_name;
      }
    }
    return "";
  }

  function buildStreetAddress(place) {
    var streetNumber = getComponent(place, "street_number", false);
    var route = getComponent(place, "route", false);
    var street = (streetNumber + " " + route).trim();
    return street || place.formatted_address || place.name || "";
  }

  function buildDisplayAddress(place, streetAddress) {
    var city =
      getComponent(place, "locality", false) ||
      getComponent(place, "postal_town", false) ||
      getComponent(place, "administrative_area_level_3", false);

    if (streetAddress && city) {
      return streetAddress + ", " + city;
    }

    return streetAddress || place.formatted_address || place.name || "";
  }

  function dispatchFieldEvents(input) {
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function dispatchFieldChange(input) {
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setSuggestionsVisible(visible) {
    var containers = document.querySelectorAll(".pac-container");
    for (var index = 0; index < containers.length; index++) {
      containers[index].style.display = visible ? "" : "none";
    }
  }

  function closeSuggestions() {
    if (!addressInput) {
      return;
    }

    addressInput.readOnly = true;
    addressInput.blur();
    setSuggestionsVisible(false);

    window.setTimeout(function () {
      setSuggestionsVisible(false);
    }, 80);

    window.setTimeout(function () {
      addressInput.readOnly = false;
    }, 220);
  }

  function setPostalCode(postalCode) {
    if (!postalCode || !postalInput) {
      return;
    }

    postalInput.value = postalCode.toUpperCase();
    dispatchFieldEvents(postalInput);
  }

  function setInvalid(message) {
    if (Date.now() < ignoreInputUntil) {
      return;
    }

    state.selected = false;
    state.withinArea = false;
    state.message = message;
    selectedStreetAddress = "";
  }

  function clearAddressError() {
    var error = document.getElementById("address-error");
    if (error) {
      error.textContent = "";
      error.style.display = "none";
    }

    if (addressInput) {
      addressInput.classList.remove("input-error");
    }
  }

  function syncSelectedAddress() {
    window.setTimeout(function () {
      if (!state.selected || !addressInput || !addressInput.value.trim()) {
        return;
      }

      selectedAddress = normalize(addressInput.value);
      clearAddressError();
    }, 160);
  }

  function applyPlace(place) {
    if (!place || !place.geometry || !place.geometry.location) {
      setInvalid("Veuillez choisir une adresse complète dans la liste Google.");
      return;
    }

    var lat = place.geometry.location.lat();
    var lng = place.geometry.location.lng();
    var province = getComponent(place, "administrative_area_level_1", true);
    var postalCode = getComponent(place, "postal_code", false);
    var distance = distanceKm(centerLat, centerLng, lat, lng);
    var streetAddress = buildStreetAddress(place);
    var displayAddress = buildDisplayAddress(place, streetAddress);

    ignoreInputUntil = Date.now() + 700;

    if (displayAddress) {
      addressInput.value = displayAddress;
      selectedAddress = normalize(displayAddress);
      selectedStreetAddress = streetAddress || displayAddress;
      dispatchFieldChange(addressInput);
    }

    setPostalCode(postalCode);

    if (!postalCode && geocoder && place.place_id) {
      geocoder.geocode({ placeId: place.place_id }, function (results, status) {
        if (status === "OK" && results && results[0]) {
          setPostalCode(getComponent(results[0], "postal_code", false));
        }
      });
    }

    state.ready = true;
    state.selected = true;
    state.withinArea = province === "QC" && distance <= radiusKm;
    state.message = state.withinArea
      ? ""
      : "Cette adresse est à l'extérieur de notre secteur de service.";

    clearAddressError();
    syncSelectedAddress();
    closeSuggestions();

    if (
      !state.withinArea &&
      typeof window.tsShowOutOfAreaNotice === "function"
    ) {
      window.setTimeout(function () {
        window.tsShowOutOfAreaNotice();
      }, 260);
    }
  }

  window.tsAddressAutocomplete = {
    isRequired: function () {
      return state.ready;
    },
    isValid: function () {
      return (
        state.ready &&
        state.selected &&
        state.withinArea &&
        normalize(addressInput.value) === selectedAddress
      );
    },
    getError: function () {
      return (
        state.message || "Veuillez choisir une adresse dans la liste Google."
      );
    },
    hasSelection: function () {
      return state.selected;
    },
    isWithinArea: function () {
      return state.withinArea;
    },
    getStreetAddress: function () {
      return selectedStreetAddress;
    },
  };

  window.tsInitAddressAutocomplete = function () {
    if (!window.google || !google.maps || !google.maps.places) {
      return;
    }

    addressInput = document.getElementById("address");
    postalInput = document.getElementById("postalCode");
    geocoder = new google.maps.Geocoder();
    if (!addressInput) {
      return;
    }

    var latDelta = radiusKm / 111;
    var lngDelta = radiusKm / (111 * Math.cos((centerLat * Math.PI) / 180));
    var bounds = new google.maps.LatLngBounds(
      { lat: centerLat - latDelta, lng: centerLng - lngDelta },
      { lat: centerLat + latDelta, lng: centerLng + lngDelta },
    );

    var autocomplete = new google.maps.places.Autocomplete(addressInput, {
      bounds: bounds,
      componentRestrictions: { country: "ca" },
      fields: [
        "address_components",
        "formatted_address",
        "geometry",
        "name",
        "place_id",
      ],
      strictBounds: false,
      types: ["address"],
    });

    state.ready = true;
    addressInput.setAttribute("autocomplete", "off");

    addressInput.addEventListener("focus", function () {
      setSuggestionsVisible(true);
    });

    addressInput.addEventListener("input", function () {
      setSuggestionsVisible(true);
      if (Date.now() < ignoreInputUntil) {
        return;
      }

      if (normalize(addressInput.value) !== selectedAddress) {
        setInvalid("Veuillez choisir une adresse dans la liste Google.");
      }
    });

    autocomplete.addListener("place_changed", function () {
      applyPlace(autocomplete.getPlace());
    });
  };
})();
